__turbopack_context__.v({
  "button": "AddToCartCTA-module-scss-module__LnsFWq__button",
  "compact": "AddToCartCTA-module-scss-module__LnsFWq__compact",
});
